// extracted by mini-css-extract-plugin
module.exports = {"xs":"375px","sm":"600px","md":"834px","lg":"1280px","xl":"1280px","wrapper":"Actions-module__wrapper___26Di_","buttons":"Actions-module__buttons___8mC5p"};